import { createStore, applyMiddleware, combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import mainState from '../Reducers/mainReducer'
import tempState from '../Reducers/tempPlaylistReducer'

const combinedReducer = combineReducers({
  mainState,
  tempState
}) 

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['tempState']
}

const persistedReducer = persistReducer(persistConfig, combinedReducer)

let middleware = [thunk];
if (false) {
  middleware = [...middleware, logger]
}

export const store = createStore(persistedReducer, applyMiddleware(...middleware))

export const pStore = persistStore(store)

// pStore.purge()



// WEBPACK FOOTER //
// ./src/js/Store/Store.js